import React from "react";
import LoadingModal from "../Common/LoadingModal";

const LoadingMessage = () => {
  return <LoadingModal message="Loading Inventory..." />;
};

export default LoadingMessage;
